<template>
<div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <faturacomp ref="faturacomp" v-model="FaturaComp"></faturacomp>
    <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>

    <v-form>
        <v-card color="grey lighten-4">
            <v-layout row wrap>
                <v-flex xs12 sm12>
                    <v-toolbar size="120px" dark color="info">
                        <v-toolbar-title> {{$t('Ticket-Refund')}} {{baslik_mesaji}}</v-toolbar-title>
                        <v-spacer></v-spacer>

                        <v-tooltip bottom>
                            <v-btn v-if="!iadeiptalbtn" :disabled="!sayfayetki.Save" slot="activator" @click="iadekaydet()" flat>
                                <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                                </span>
                                <v-icon right dark>add_box</v-icon>
                            </v-btn>
                            <span v-if="!sayfayetki.Save"> {{ $t('Limited-Authorization') }} </span>
                            <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <v-btn v-if="iadeiptalbtn" :disabled="!sayfayetki.Update" slot="activator" @click="iadekaydet()" flat>
                                <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down">
                                    {{ $t('Update') }}
                                </span>
                                </span>
                                <v-icon right dark>edit</v-icon>
                            </v-btn>
                            <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }} </span>
                            <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
                        </v-tooltip>

                        <v-menu bottom left>
                            <v-btn slot="activator" dark icon>
                                <v-icon>more_vert</v-icon>
                            </v-btn>
                            <v-list>

                                <v-tooltip bottom>
                                    <v-list-tile slot="activator" :disabled="iadefaturami" @click="iadeFaturala()">
                                        <v-list-tile-title>{{ $t('Refund-Invoice') }}</v-list-tile-title>
                                    </v-list-tile>
                                    <span>{{ $t('Refund-Invoice') }}</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <v-list-tile v-if="iadeiptalbtn" slot="activator" :disabled="!sayfayetki.Delete" @click="iadeiptal()">
                                        <v-list-tile-title>{{ $t('Delete-Return') }}</v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Delete"> {{ $t('Limited-Authorization') }} </span>
                                    <span v-if="sayfayetki.Delete">{{ $t('Delete-Return') }}</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <v-list-tile v-if="yeniiadebtn" slot="activator" :disabled="!sayfayetki.Save" @click="yeniiadeekle()">
                                        <v-list-tile-title>{{ $t('Add-New-Return') }}</v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Save"> {{ $t('Limited-Authorization') }} </span>
                                    <span v-if="sayfayetki.Save">{{ $t('Add-New-Return') }}</span>
                                </v-tooltip>

                                <v-list-tile @click="sayfakapatiade()">
                                    <v-list-tile-title>{{$t("cancel_button")}}</v-list-tile-title>
                                </v-list-tile>

                            </v-list>
                        </v-menu>
                    </v-toolbar>

                </v-flex>

                <v-container fluid>
                    <v-layout row="" wrap="">
                        <v-flex pa-1 xs12 sm6 md3>
                            <v-card class="white--text">
                                <v-card flat="">
                                    <v-card-actions>
                                        <v-layout justify-space-between column>
                                            <tarihcomp :etiket="$t('Refund-Date')" :tabindex="'1'" v-bind:defaultvalue="'ok'" v-bind:value="BiletIade.TarihBilgileri.IadeTarihi" v-model="BiletIade.TarihBilgileri.IadeTarihi"></tarihcomp>
                                            <cariaracomp  tabindex="2" v-bind:etiket="$t('Refund-Account-Code')" v-bind:value="BiletIade.GenelBilgileri.Cari.Kod" v-model="BiletIade.GenelBilgileri.Cari.Kod" v-bind:statecariyedek="statecari" :Coper="false"></cariaracomp>
                                            <tarihcomp :etiket="$t('Expiry-Return')" :tabindex="'3'" v-bind:defaultvalue="'ok'" v-bind:value="BiletIade.TarihBilgileri.VadeTarihi" v-model="BiletIade.TarihBilgileri.VadeTarihi"></tarihcomp>
                                            <v-layout>
                                                <tarihcomp :etiket="$t('Refund-Invoice-Date')" :tabindex="'4'" v-bind:defaultvalue="'ok'" v-bind:value="BiletIade.TarihBilgileri.IadeFaturaTarihi" v-model="BiletIade.TarihBilgileri.IadeFaturaTarihi"></tarihcomp>
                                                <v-text-field hide-details="" tabindex="5" v-model="BiletIade.FaturaBilgileri.IadeFaturaNo" maxlength="10" label="İade Fat.No"></v-text-field>
                                            </v-layout>
                                            <v-text-field hide-details="" tabindex="6" v-model="BiletIade.FaturaBilgileri.IadeFaturaGelenBelgeNo" :label="$t('Refund-Invoice-Document-No')">
                                            </v-text-field>
                                            <v-checkbox :label="$t('Payment-made')" tabindex="7" v-model="BiletIade.OdemeBilgileri.Odeme" hide-details=""></v-checkbox>
                                            <v-text-field hide-details="" tabindex="8" v-model="BiletIade.FaturaBilgileri.DekontNo" label="Dekont No" mask="####################"></v-text-field>
                                            <kesenkisi v-bind:etiket="$t('Person-Accepting-the-Refund')" v-model="BiletIade.GenelBilgileri.KesenKisi">
                                            </kesenkisi>
                                            <v-text-field tabindex="10" v-model="BiletIade.FaturaBilgileri.ServisFaturaNo" hide-details="" :label="$t('Service-Invoice-No')"></v-text-field>
                                            <v-textarea :label="$t('Notes')" tabindex="11" v-model="BiletIade.GenelBilgileri.Notlar" hide-details=""></v-textarea>

                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-card>
                        </v-flex>

                        <v-flex pa-1 xs12 sm6 md3>
                            <v-card color="grey-lighten-4">
                                <v-card flat="">
                                    <v-card-actions>
                                        <v-layout justify-space-between column>
                                            <v-text-field hide-details="" tabindex="12" v-model="BiletIade.GenelBilgileri.Parkurlar.Parkur1" :label="$t('Route') + '1'"></v-text-field>
                                            <v-text-field hide-details="" tabindex="13" v-model="BiletIade.GenelBilgileri.Parkurlar.Parkur2" :label="$t('Route') + '2'"></v-text-field>
                                            <v-text-field hide-details="" tabindex="14" v-model="BiletIade.GenelBilgileri.Parkurlar.Parkur3" :label="$t('Route') + '3'"></v-text-field>

                                            <v-text-field hide-details="" tabindex="15" v-model="BiletIade.GenelBilgileri.Parkurlar.Parkur4" :label="$t('Route') + '4'"></v-text-field>
                                            <v-text-field hide-details="" tabindex="16" v-model="BiletIade.GenelBilgileri.Parkurlar.Parkur5" :label="$t('Route') + '5'"></v-text-field>

                                            <tarihcomp :aktifmi="true" :etiket="$t('Return-Sales-Invoice-Date')" v-bind:defaultvalue="'no'" v-bind:value="BiletIade.FaturaBilgileri.IadeSatisFaturaTarihi" v-model="BiletIade.FaturaBilgileri.IadeSatisFaturaTarihi"></tarihcomp>

                                            <v-layout>
                                                <v-text-field :disabled="true" hide-details="" v-model="BiletIade.FaturaBilgileri.IadeSatisFaturaSeri" :label="$t('Invoice-Serial')"></v-text-field>
                                                <v-text-field :disabled="true" hide-details="" v-model="BiletIade.FaturaBilgileri.IadeSatisFaturaNo" :label="$t('Invoice-No')"></v-text-field>

                                            </v-layout>

                                            <v-radio-group :label="$t('Refunded-Flight')" tabindex="17" v-model="BiletIade.GenelBilgileri.IadeUcusTip">
                                                <v-radio :label="$t('Departure')" value="G"></v-radio>
                                                <v-radio :label="$t('Return')" value="D"></v-radio>
                                                <v-radio :label="$t('Complete')" value="T"></v-radio>
                                            </v-radio-group>
                                            <v-radio-group :label="$t('Receipt-Note-of-Expenses')" tabindex="18" v-model="BiletIade.DigerBilgileri.DekontPusula">
                                                <v-radio :label="$t('Print-Receipt')" value="D"></v-radio>
                                                <v-radio :label="$t('Print-Note-of-Expenses')" value="P"></v-radio>
                                            </v-radio-group>
                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-card>
                        </v-flex>

                        <v-flex pa-1 xs12 sm12 md6>
                            <v-card color="grey-lighten-4">
                                <v-card flat="">
                                    <v-card-actions>

                                        <v-layout justify-space-between column>

                                            <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Total')" :aktif="'true'" v-model="BiletIade.TutarBilgileri.NetTutar.NetTutar" :autocomplete="'autocomplete'">
                                                    </parainput>
                                                </v-flex>
                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Currency-Buying-Amount')" :aktif="'true'" v-model="BiletIade.TutarBilgileri.NetTutar.NetTutarAlisDoviz" :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>
                                                <v-flex xs4 sm4 md4>
                                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Selling-Amount')" :aktif="'true'" v-model="BiletIade.TutarBilgileri.NetTutar.NetTutarSatisDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                                </v-flex>

                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Amount-Without-Penalty')" :aktif="'true'" v-model="BiletIade.CezasızTutar" :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>

                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Amount')" :tabdeger="19" v-model="BiletIade.TutarBilgileri.Tutar.Tutar" :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>

                                                <v-flex xs4 sm4 md4>

                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Currency-Buying-Amount')" :tabdeger="20" v-model="BiletIade.TutarBilgileri.Tutar.TutarAlisDoviz" :autocomplete="'autocomplete'">
                                                    </parainput>
                                                </v-flex>

                                                <v-flex xs4 sm4 md4>

                                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Selling-Amount')" :tabdeger="21" v-model="BiletIade.TutarBilgileri.Tutar.TutarSatisDoviz" :autocomplete="'autocomplete'">
                                                    </doviztutarcomp>
                                                </v-flex>

                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>

                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Penalty')" :tabdeger="22" v-model="BiletIade.TutarBilgileri.CezaTutar.CezaTutar" :autocomplete="'autocomplete'">
                                                    </parainput>
                                                </v-flex>

                                                <v-flex xs4 sm4 md4>

                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Currency-Buying-Amount')" :tabdeger="23" v-model="BiletIade.TutarBilgileri.CezaTutar.CezaAlisTutar" :autocomplete="'autocomplete'">
                                                    </parainput>
                                                </v-flex>

                                                <v-flex xs4 sm4 md4>

                                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Selling-Amount')" :tabdeger="24" v-model="BiletIade.TutarBilgileri.CezaTutar.CezaSatisTutar" :autocomplete="'autocomplete'"></doviztutarcomp>
                                                </v-flex>

                                            </v-layout>
                                            <v-layout row wrap>

                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Landing-Tax')" :tabdeger="25" v-model="BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiTutar" :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>

                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Currency-Buying-Amount')" :tabdeger="26" v-model="BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiAlisDoviz" :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>

                                                <v-flex xs4 sm4 md4>
                                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Selling-Amount')" :tabdeger="27" v-model="BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                                </v-flex>

                                            </v-layout>

                                            <v-layout row wrap>

                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Tax-Amount')" :aktif="icHat" :tabdeger="25" v-model="BiletIade.TutarBilgileri.TaxTutar.TaxTutar" :autocomplete="'autocomplete'">
                                                    </parainput>
                                                </v-flex>

                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Currency-Buying-Amount')" :aktif="icHat" :tabdeger="26" v-model="BiletIade.TutarBilgileri.TaxTutar.TaxAlisDoviz" :autocomplete="'autocomplete'">
                                                    </parainput>
                                                </v-flex>

                                                <v-flex xs4 sm4 md4>
                                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Selling-Amount')" :aktif="icHat" :tabdeger="27" v-model="BiletIade.TutarBilgileri.TaxTutar.TaxSatisDoviz" :autocomplete="'autocomplete'">
                                                    </doviztutarcomp>
                                                </v-flex>

                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>

                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Fuel-Price-Difference')" :tabdeger="31" v-model="BiletIade.TutarBilgileri.YffTutar.YFFTutar" :autocomplete="'autocomplete'">
                                                    </parainput>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Refund-Service-Fee')" :tabdeger="32" v-model="BiletIade.TutarBilgileri.IadeServisTutar.IadeServisTutar" :autocomplete="'autocomplete'"></parainput>

                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('KA-Tax')" :tabdeger="33" v-model="BiletIade.TutarBilgileri.KaTutar.KaTutar" :autocomplete="'autocomplete'">
                                                    </parainput>

                                                </v-flex>

                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :aktif="iadefaturami" :etiket="$t('Service-Fee')" :tabdeger="34" v-model="BiletIade.TutarBilgileri.ServisTutar.ServisTutar" :autocomplete="'autocomplete'">
                                                    </parainput>

                                                </v-flex>

                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="this.$t('Discount')" :tabdeger="35" v-model="BiletIade.TutarBilgileri.IskontoTutar.IskontoTutar" :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>
                                                <v-flex xs4 sm4 md4>

                                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Selling-Amount')" :tabdeger="36" v-model="BiletIade.TutarBilgileri.IskontoTutar.IskontoDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                                </v-flex>

                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Other-Service')" :tabdeger="37" v-model="BiletIade.TutarBilgileri.DigerServisTutar.DigerServisTutar" :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>
                                                <v-flex xs4 sm4 md4>
                                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Selling-Amount')" :tabdeger="38" v-model="BiletIade.TutarBilgileri.DigerServisTutar.DigerServisDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="reserveName" :tabdeger="39" v-model="BiletIade.TutarBilgileri.ReserveTutar.ReserveTutar" :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>
                                                <v-flex xs4 sm4 md4>
                                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Selling-Amount')" :tabdeger="40" v-model="BiletIade.TutarBilgileri.ReserveTutar.ReserveDoviz" :autocomplete="'autocomplete'"></doviztutarcomp>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'HY Tutar'" :tabdeger="41" v-model="BiletIade.OdemeBilgileri.HavayoluTutar" :autocomplete="'autocomplete'">
                                                    </parainput>
                                                </v-flex>

                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Amount-with-Credit')" :tabdeger="42" v-model="BiletIade.OdemeBilgileri.KrediliTutar" :autocomplete="'autocomplete'">
                                                    </parainput>
                                                </v-flex>

                                                <v-flex xs4 sm4 md4>
                                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Amount')" :tabdeger="43" v-model="BiletIade.OdemeBilgileri.KrediliDvzTutar" :autocomplete="'autocomplete'">
                                                    </doviztutarcomp>
                                                </v-flex>

                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Amount-Paid-in-Advance')" :tabdeger="44" v-model="BiletIade.OdemeBilgileri.PesinTutar" :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>

                                                <v-flex xs4 sm4 md4>
                                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Amount')" :tabdeger="45" v-model="BiletIade.OdemeBilgileri.PesinDvzTutar" :autocomplete="'autocomplete'">
                                                    </doviztutarcomp>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Amount-with-Credit-Card')" :tabdeger="46" v-model="BiletIade.OdemeBilgileri.KrediKartTutar" :autocomplete="'autocomplete'">
                                                    </parainput>
                                                </v-flex>
                                                <v-flex xs4 sm4 md4>
                                                    <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Amount')" :tabdeger="47" v-model="BiletIade.OdemeBilgileri.KrediKartDvzTutar" :autocomplete="'autocomplete'">
                                                    </doviztutarcomp>
                                                </v-flex>

                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>
                                                    <v-text-field hide-details="" tabindex="48" v-model="BiletIade.OdemeBilgileri.Analiz.AnalizKod" :label="$t('Analysis-Code')"></v-text-field>
                                                </v-flex>

                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Analysis-Amount')" :tabdeger="49" v-model="BiletIade.OdemeBilgileri.AnalizTutar" :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>

                                                <v-flex xs4 sm4 md4>
                                                    <doviztutarcomp :isPositive="true" :etiket="$t('Analysis-Currency-Amount')" :tabdeger="50" v-model="BiletIade.OdemeBilgileri.AnalizDvzTutar" :autocomplete="'autocomplete'">
                                                    </doviztutarcomp>
                                                </v-flex>

                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>
                                                    <v-text-field hide-details="" tabindex="51" v-model="BiletIade.OdemeBilgileri.Analiz1.AnalizKod" :label="$t('Analysis-Code') + '1'"></v-text-field>
                                                </v-flex>

                                                <v-flex xs4 sm4 md4>
                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Analysis-Amount')+'1'" :tabdeger="52" v-model="BiletIade.OdemeBilgileri.AnalizTutar1" :autocomplete="'autocomplete'">
                                                    </parainput>
                                                </v-flex>

                                                <v-flex xs4 sm4 md4>
                                                    <doviztutarcomp :isPositive="true" :etiket="$t('Analysis-Currency-Amount')" :tabdeger="53" v-model="BiletIade.OdemeBilgileri.AnalizDvzTutar1" :autocomplete="'autocomplete'">
                                                    </doviztutarcomp>
                                                </v-flex>

                                            </v-layout>

                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>

            </v-layout>
        </v-card>
    </v-form>

    <v-dialog v-model="dialogkisamesaj" width="500">

        <v-card>
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title>{{ $t('Warning') }}!</v-toolbar-title>
                </v-toolbar>
            </v-flex>

            <v-card-text>
                {{this.kisamesaj}}
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="dialogkisamesaj = false">
                    {{ $t('OK') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="loadingdialogkayit" hide-overlay persistent width="400">
        <v-card color="primary" dark>
            <v-card-text>
                {{$t('Processing-please-wait')}} ...
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="loadingdialog" hide-overlay persistent width="400">
        <v-card color="primary" dark>
            <v-card-text>
                {{ $t('Preparing-ticket-please-wait') }} ...
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>

    <template>
        <v-card>
            <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
            </v-snackbar>
        </v-card>
    </template>
</div>
</template>

<script>
import auth from '../../../api/auth'
import parainput from '../customcomp/parainput'
import yuzdeinput from '../customcomp/yuzdeinput'
import dovizinput from '../customcomp/dovizinput'
import tarihcomp from '../customcomp/tarihim'
import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
import doviztutarcomp from '@/components/app/customcomp/doviztutarcomp.vue'
import helpers from "@/components/app/customcomp/helpers.js"
import kesenkisi from '../customcomp/kesenkisi'
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
import faturacomp from "@/components/app/bilet/partpage/faturacomp.vue"
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";

export default {
    data() {
        return {
            reserveName:null,
            sayfayetki: {
                Screen: false,
                Update: false,
                Save: false,
                Delete: false,
                Status: false,
                Message: null,
                islem: 0
            },
            iadefaturami: false,
            BiletIade: {
                GenelBilgileri: {
                    SirketKodu: '',
                    BiletNo: '',
                    Formno: '',
                    HavaYoluKodu: '',
                    Sirano: '',
                    UcusTip: '',
                    Cari: {
                        Kod: ''
                    },
                    Parkurlar: {
                        Parkur1: '',
                        Parkur2: '',
                        Parkur3: '',
                        Parkur4: '',
                        Parkur5: ''
                    },
                    IadeUcusTip: '', //enum
                    KesenKisi: '',
                    Masraf: {
                        Code: ''
                    },
                    Referans: {
                        Kod: ''
                    },
                    Crs: '', // enum
                    Notlar: '',
                    IadeSirano: 0
                },
                TarihBilgileri: {
                    IadeTarihi: null,
                    VadeTarihi: null,
                    IadeFaturaTarihi: null
                },
                FaturaBilgileri: {
                    IadeFaturaNo: null,
                    DekontNo: null,
                    ServisFaturaNo: null,
                    IadeFaturaGelenBelgeNo: null,
                    IadeSatisFaturaNo: null,
                    IadeSatisFaturaSeri: null,
                    IadeSatisFaturaTarihi: null,
                },
                TutarBilgileri: {
                    Doviz: {
                        DovizKod: null
                    },
                    Kur: 0,
                    CezasizTutar: 0,
                    NetTutar: {
                        NetTutar: 0,
                        NetTutarSatisDoviz: 0,
                        NetTutarAlisDoviz: 0,
                        NetTutarKdv: 0,
                    },
                    Tutar: {
                        Tutar: 0,
                        TutarSatisDoviz: 0,
                        TutarAlisDoviz: 0,
                        TutarKdv: 0,
                    },
                    AlanVergiTutar: {
                        AlanVergiTutar: 0,
                        AlanVergiSatisDoviz: 0,
                        AlanVergiAlisDoviz: 0,
                        AlanVergiKdv: 0
                    },
                    TaxTutar: {
                        TaxTutar: 0,
                        TaxSatisDoviz: 0,
                        TaxAlisDoviz: 0,
                        TaxKdv: 0
                    },
                    YffTutar: {
                        YFFTutar: 0,
                        YFFDoviz: 0,
                        YFFKdv: 0
                    },
                    IskontoTutar: {
                        IskontoYuzde: 0,
                        IskontoTutar: 0,
                        IskontoDoviz: 0,
                        IskontoKdv: 0
                    },
                    CezaTutar: {
                        CezaTutar: 0,
                        CezaSatisTutar: 0,
                        CezaAlisTutar: 0,
                        CezaKdv: 0,
                    },
                    KaTutar: {
                        KaTutar: 0,
                        KaDoviz: 0,
                        KaKdv: 0
                    },
                    ServisTutar: {
                        ServisTutar: 0,
                        ServisDoviz: 0,
                        ServisKdv: 0
                    },
                    IadeServisTutar: {
                        IadeServisTutar: 0,
                        IadeServisDoviz: 0,
                        IadeServisKdv: 0
                    },
                    DigerServisTutar: {
                        DigerServisTutar: 0,
                        DigerServisDoviz: 0,
                        DigerServisKdv: 0
                    },
                    ReserveTutar: {
                        ReserveYuzde: 0,
                        ReserveTutar: 0,
                        ReserveDoviz: 0,
                        ReserveKdv: 0
                    }
                },
                OdemeBilgileri: {
                    Odeme: false,
                    KrediliTutar: 0,
                    KrediliDvzTutar: 0,
                    PesinTutar: 0,
                    PesinDvzTutar: 0,
                    KrediKartTutar: 0,
                    KrediKartDvzTutar: 0,
                    HY: 0,
                    GSA: 0,
                    HavayoluTutar: 0,
                    Analiz: {
                        AnalizKod: ''
                    },
                    AnalizTutar: 0,
                    AnalizDvzTutar: 0,
                    Analiz1: {
                        AnalizKod: ''
                    },
                    AnalizTutar1: 0,
                    AnalizDvzTutar1: 0,
                },
                DigerBilgileri: {
                    IadeTanim: null,
                    Entegre: null,
                    ExIcDis: null,
                    CkLogId: null,
                    ParkurTip: null,
                    KKEnt: null,
                    IadeDekontID: null,
                    IadeMaliyetDekontID: null,
                    IadeSapEntegre: null,
                    IadeMaliyetSapEntegre: null,
                    // public Guid EntegrasyonID { get; set; }
                    ServisFark: false,
                    DekontPusula: '', //enum
                    AlisEntegre: null,
                },
                LoginBilgileri: {
                    UserID: null,
                    Email: null,
                    MusteriKodu: null,
                    SigortaSirket: null,
                    CariSirket: null,
                    BiletSirket: null,
                    CoperSirket: null
                }
            },
            FaturaComp: {
                Fatura: {
                    SirketKodu: null,
                    FaturaTarih: null,
                    FaturaSeri: null,
                    FaturaNo: null,
                    GibSeri: null,
                    BiletBilgi: {
                        SirketKodu: null,
                        BiletNo: null,
                        FormNo: null,
                        OdemeTarihi: null,
                        CariKod: [],
                        NetTutar: 0

                    },
                    EFaturaBilgi: {
                        Unvani: null,
                        Unvani2: null,
                        Adres1: null,
                        Adres2: null,
                        IlceSehir: null,
                        Email: null,
                        VergiDairesi: null,
                        VergiNo: null,
                        TcKimlikNo: null,
                        Adi: null,
                        Soyadi: null,
                        TUnvani: null,
                        DigerAdi: null,
                        OnAdiEki: null,
                    },
                    FaturaBilgi: {
                        FaturaTip: 'O',
                        FaturaID: 2,
                        FaturaXSLTID: null,
                        FaturaPdfID: 0,
                        FaturaDipAciklama: null
                    },
                    Opsiyonlar: {
                        YolcuGosterme: false,
                        DovizliFatura: false,
                        FaturaDetayBas: false
                    },
                    EArsivBilgi: {
                        GonderimSekli: null,
                        InternetSatis: null,
                        WebAdresi: null,
                        OdemeSekli: null,
                        OdemeSekliAciklama: null,
                        OdemeAraci: null,
                        OdemeTarihi: null,
                    },
                    DovizBilgi: {
                        EDovizTipi: null,
                        EKur: 0,
                        DDovizTipi: null,
                        DKur: 0
                    }
                },
                Dialog: false,
                UcusTipi: null,
            },
            SatisSekli: null,
            ToplamTutar: 0,
            CezasızTutar: 0,
            Referans: [],
            iadeiptalbtn: false,
            yeniiadebtn: false,
            baslik_mesaji: '',
            loadingdialogkayit: false,
            loadingdialog: false,
            dialog_baslik: '',
            m: false,
            k: false,
            progress: false,
            baslik: '',
            e1: 0,
            Code: '',
            e2: true,
            yok: false,
            statecari: [],
            search: '',
            loading: false,
            doviztipi: [],
            kisamesaj: '',
            dialogkisamesaj: false,
            guncellebuton: false,
            masrafmerkezi: [],
            taksitsayiservis: [],
            taksitsayitahsilat: [],
            itemsbanka: [],
            bolumler: [],
            dictionary: {
                custom: {
                    carikod: {
                        required: () => this.$t('This-space-cannot-left-blank'),

                    },
                    cariseciniz: {
                        required: () => this.$t('This-space-cannot-left-blank'),

                    },
                    unvan: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                        min: () => this.$t('Must-least-4-digits'),
                    },

                }
            },
            kaydetbuton: false,
            datesatistarihi: null,
            date: null,
            menu: false,
            modal: false,
            dateFormatted: '',
            text1: '',
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            carikod: '',
            unvan: '',
            active: '',
            icHat:false
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from.path
        })
    },
    mounted() {
        this.$validator.localize('en', this.dictionary)

        this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
        if (this.sayfayetki.Status == true) {

            if(this.$route.query.ucustipi == 'I'){
                this.icHat = true;
            }
            
            this.getReserveName();

            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            var params1 = {
                CompanyCode: credentials.SirketKodu
            }

            this.$http.post(auth.API_URL + 'api/Definitions/SectionList', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.bolumler = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })

            this.$http.post(auth.API_URL + 'api/Analysis/List', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.progress = false
                this.analizitems = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.progress = false
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.progress = false
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })

            this.$http.post(auth.API_URL + 'api/currency/List', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.doviztipi = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-Döviz'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-Döviz'
                    this.snackbar = true
                }
            })

            this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.masrafmerkezi = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-Masraf Merkezi'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-Masraf Merkezi'
                    this.snackbar = true
                }
            })

            this.progress = true

            this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurList', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.itemsparkur = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.progress = false

                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.progress = false
                    this.snackbar = true
                }
            })

            this.$http.post(auth.API_URL + 'api/TicketDefinitons/ClassList', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.classitems = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.progress = false

                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.progress = false

                    this.snackbar = true
                }
            })

            this.$http.post(auth.API_URL + 'api/BankPos/List', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.bankapositems = response.body
                this.progress = false
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.progress = false
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                    this.progress = false
                }
            })
               //referance list kaldırıldı
            // this.$http.post(auth.API_URL + 'api/Reference/List', params1, {
            //     headers: {
            //         'Authorization': 'Bearer ' + auth.getAuthHeader()
            //     }
            // }).then((response) => {
            //     this.Referans = response.body

            // }, (response) => {
            //     if (response.status === 0) {
            //         this.text1 = 'Service Unavailable-Referans'
            //         this.snackbar = true
            //     } else {
            //         this.text1 = 'Service Unavailable-Referans'
            //         this.snackbar = true
            //     }
            // })

            if (this.$route.query.isl == 'iadeget') {

                var iadeparams = {
                    SirketKodu: credentials.SirketKodu,
                    BiletNo: this.$route.query.biletno,
                    HavaYoluKodu: this.$route.query.hyolukod,
                    FormNo: this.$route.query.formno,
                    Sirano: this.$route.query.sirano,
                }

                this.$http.post(auth.API_URL + 'api/Ticket/RefundLoad', iadeparams, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    this.BiletIade = response.body

                    this.BiletIade.GenelBilgileri.UcusTip = this.$route.query.ucustipi
                    this.BiletIade.TutarBilgileri.CezasizTutar = this.BiletIade.TutarBilgileri.NetTutar.NetTutar + this
                        .BiletIade
                        .TutarBilgileri.CezaTutar.CezaTutar

                    if (response.body.TutarBilgileri.Kur == 0) {

                        if (response.body.TutarBilgileri.Tutar.TutarSatisDoviz != 0) {
                            this.BiletIade.TutarBilgileri.Kur = response.body.TutarBilgileri.Tutar.Tutar / response.body
                                .TutarBilgileri.Tutar.TutarSatisDoviz
                        } else {
                            this.BiletIade.TutarBilgileri.Kur = 1
                        }

                    } else {
                        this.BiletIade.TutarBilgileri.Kur = response.body.TutarBilgileri.Kur
                    }

                    this.BiletIade.TutarBilgileri.Tutar.Tutar = response.body.TutarBilgileri.Tutar.Tutar
                    this.BiletIade.TutarBilgileri.AlanVergiTutar = response.body.TutarBilgileri.AlanVergiTutar
                    this.BiletIade.TutarBilgileri.TaxTutar = response.body.TutarBilgileri.TaxTutar
                    this.BiletIade.TutarBilgileri.YffTutar = response.body.TutarBilgileri.YffTutar
                    this.BiletIade.TutarBilgileri.IskontoTutar = response.body.TutarBilgileri.IskontoTutar
                    this.BiletIade.TutarBilgileri.CezaTutar = response.body.TutarBilgileri.CezaTutar
                    this.BiletIade.TutarBilgileri.KaTutar = response.body.TutarBilgileri.KaTutar
                    this.BiletIade.TutarBilgileri.DigerServisTutar = response.body.TutarBilgileri.DigerServisTutar
                    this.BiletIade.TutarBilgileri.ReserveTutar = response.body.TutarBilgileri.ReserveTutar

                    if (this.BiletIade.FaturaBilgileri.IadeSatisFaturaNo != 0 && this.BiletIade.FaturaBilgileri.IadeSatisFaturaSeri !=
                        null) {
                        this.iadefaturami = true
                    } else {
                        this.iadefaturami = false

                    }

                    // sadece satış şeklini almak için burada get yapıyoruz iade classında yok

                    var biletparams = {
                        SirketKodu: credentials.SirketKodu,
                        BiletNo: this.$route.query.biletno,
                        HavaYoluKodu: this.$route.query.hyolukod,
                        UcusTipi: this.$route.query.ucustipi
                    }

                    this.$http.post(auth.API_URL + 'api/Ticket/TicketGet', biletparams, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {

                        this.SatisSekli = response.body.OdemeBilgileri.SatisSekli
                         
                        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                        this.FaturaComp.Fatura.SirketKodu = credentials.SirketKodu

                        this.FaturaComp.UcusTipi = response.body.GenelBilgileri.UcusTipi
                        this.FaturaComp.Fatura.BiletBilgi.BiletNo = response.body.GenelBilgileri.BiletNo
                        this.FaturaComp.Fatura.BiletBilgi.FormNo = response.body.GenelBilgileri.Formno
                        this.FaturaComp.Fatura.BiletBilgi.UcusTip = response.body.GenelBilgileri.UcusTipi
                        this.FaturaComp.Fatura.BiletBilgi.OdemeTarihi = response.body.TarihBilgileri.OdemeTarihi
                        this.FaturaComp.Fatura.BiletBilgi.CariKod = response.body.GenelBilgileri.MusteriKodu
                        this.FaturaComp.Fatura.BiletBilgi.NetTutar = response.body.TutarBilgileri.NetTutar.NetTutar
                        this.FaturaComp.Fatura.EArsivBilgi.GonderimSekli = response.body.FaturaBilgileri.EfaturaBilgileri
                            .GonderimSekli
                        this.FaturaComp.Fatura.EArsivBilgi.InternetSatis = response.body.FaturaBilgileri.EfaturaBilgileri
                            .InternetSatis
                        this.FaturaComp.Fatura.EArsivBilgi.OdemeSekli = response.body.FaturaBilgileri.EfaturaBilgileri
                            .OdemeSekli
                        this.FaturaComp.Fatura.EArsivBilgi.OdemeSekliAciklama = response.body.FaturaBilgileri
                            .EfaturaBilgileri
                            .OdemeSekliAciklama
                        this.FaturaComp.Fatura.EArsivBilgi.OdemeAraci = response.body.FaturaBilgileri.EfaturaBilgileri
                            .OdemeAraci
                        this.FaturaComp.Fatura.EArsivBilgi.OdemeTarihi = response.body.FaturaBilgileri.EfaturaBilgileri
                            .OdemeTarihi

                        if (this.FaturaComp.Fatura.EArsivBilgi.OdemeTarihi == null || this.FaturaComp.Fatura.EArsivBilgi
                            .OdemeTarihi ==
                            '0001-01-01T00:00:00') {
                            this.FaturaComp.Fatura.EArsivBilgi.OdemeTarihi = response.body.TarihBilgileri.SatisTarihi
                        }
                        this.FaturaComp.Fatura.EArsivBilgi.WebAdresi = response.body.FaturaBilgileri.EfaturaBilgileri
                            .WebAdresi

                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                        }
                    })

                    this.iadeiptalbtn = true
                    this.yeniiadebtn = true
                    this.biletnodisabled = false

                    var yeniitems = [{
                        id: response.body.GenelBilgileri.Cari.Kod,
                        unvan1: response.body.GenelBilgileri.MusteriKodu.Unvan,
                        unvan2: response.body.GenelBilgileri.MusteriKodu.Unvani2,
                        autoText: response.body.GenelBilgileri.MusteriKodu.Unvan + "-" + response.body.GenelBilgileri.MusteriKodu.Unvani2
                    }]
                    if (response.body.GenelBilgileri.MusteriKodu.Kod != null) {
                        this.statecari.push(yeniitems)
                    }


                }, (response) => {
                    if (response.status === 0) {} else {}
                })
            } else if (this.$route.query.isl == 'yeniiade') {

                this.iadeiptalbtn = false
                this.yeniiadebtn = false
                this.BiletIade.GenelBilgileri.BiletNo = this.$route.query.biletno
                this.BiletIade.GenelBilgileri.Formno = this.$route.query.formno
                this.BiletIade.GenelBilgileri.HavaYoluKodu = this.$route.query.hyolukod
                this.BiletIade.GenelBilgileri.UcusTip = this.$route.query.ucustipi

                var biletparams = {
                    SirketKodu: credentials.SirketKodu,
                    BiletNo: this.$route.query.biletno,
                    HavaYoluKodu: this.$route.query.hyolukod,
                    UcusTipi: this.$route.query.ucustipi
                }

                this.$http.post(auth.API_URL + 'api/Ticket/TicketGet', biletparams, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    var yeniitems = [{
                        id: response.body.GenelBilgileri.MusteriKodu.Kod,
                        unvan1: response.body.GenelBilgileri.MusteriKodu.Unvan,
                        unvan2: response.body.GenelBilgileri.MusteriKodu.Unvani2,
                        autoText: response.body.GenelBilgileri.MusteriKodu.Unvan + "-" + response.body.GenelBilgileri.MusteriKodu.Unvani2
                    }]
                    if (response.body.GenelBilgileri.MusteriKodu.Kod != null) {
                        this.statecari.push(yeniitems)
                    }

                    this.BiletIade.GenelBilgileri.Cari.Kod = response.body.GenelBilgileri.MusteriKodu.Kod
                    this.BiletIade.GenelBilgileri.Parkurlar = response.body.GenelBilgileri.Parkurlar
                    this.BiletIade.GenelBilgileri.Referans.Kod  = response.body.GenelBilgileri.Referans.Kod;
                    this.BiletIade.GenelBilgileri.Masraf.Code  = response.body.GenelBilgileri.Masraf.Code;

                    // tutar bilgilerini yazalım

                    if (response.body.TutarBilgileri.Kur == 0) {

                        if (response.body.TutarBilgileri.Tutar.TutarSatisDoviz != 0) {
                            this.BiletIade.TutarBilgileri.Kur = response.body.TutarBilgileri.Tutar.Tutar / response.body
                                .TutarBilgileri.Tutar.TutarSatisDoviz
                        } else {
                            this.BiletIade.TutarBilgileri.Kur = 1
                        }

                    } else {
                        this.BiletIade.TutarBilgileri.Kur = response.body.TutarBilgileri.Kur
                    }

                    this.BiletIade.TutarBilgileri.Tutar.Tutar = response.body.TutarBilgileri.Tutar.Tutar
                    this.BiletIade.TutarBilgileri.AlanVergiTutar = response.body.TutarBilgileri.AlanVergiTutar
                    this.BiletIade.TutarBilgileri.TaxTutar = response.body.TutarBilgileri.TaxTutar
                    this.BiletIade.TutarBilgileri.YffTutar = response.body.TutarBilgileri.YFFTutar
                    this.BiletIade.TutarBilgileri.IskontoTutar = response.body.TutarBilgileri.IskontoTutar
                    this.BiletIade.TutarBilgileri.CezaTutar = response.body.TutarBilgileri.CezaTutar
                    this.BiletIade.TutarBilgileri.KaTutar = response.body.TutarBilgileri.KaTutar
                    this.BiletIade.TutarBilgileri.DigerServisTutar = response.body.TutarBilgileri.DigerServisTutar
                    this.BiletIade.TutarBilgileri.ReserveTutar = response.body.TutarBilgileri.ReserveTutar
                    this.SatisSekli = response.body.OdemeBilgileri.SatisSekli
                    
if (this.SatisSekli=='R')// eger satis sekli kredi kartı ise ödeme yapıldı ticki seçili geliyor
{
    this.BiletIade.OdemeBilgileri.Odeme=true;
}
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })

            }
           
        } else {

            this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

                if (sonuc == true) {

                    if (this.prevRoute != null) {
                        let url = '#' + this.prevRoute
                        window.open(url, '_self')
                    } else {
                        let url = '#/'
                        window.open(url, '_self')
                    }
                }

            });

        }
    },
    methods: {
        getReserveName(){
         var credentials = JSON.parse(window.localStorage.getItem('credentials'));

         var params1 = {
             CompanyCode: credentials.SirketKodu
         }

         this.$http.post(auth.API_URL + 'api/TicketHelpers/GetReserveName', params1, {
             headers: {
                 'Authorization': 'Bearer ' + auth.getAuthHeader()
             }
         }).then((response) => {
             this.reserveName = response.body
         }, (response) => {
             if (response.status === 0) {
                 this.text1 = 'Service Unavailable-class'
                 this.progress = false
                 this.snackbar = true
             } else {
                 this.text1 = 'Service Unavailable-class'
                 this.progress = false
                 this.snackbar = true
             }
         })

        },
        getparabirimi() {
            return helpers.getparabirimi()
        },
        iadeFaturala() {
            this.FaturaComp.Fatura.BiletBilgi.ServisTutar = this.BiletIade.TutarBilgileri.ServisTutar.ServisTutar

            this.FaturaComp.Dialog = true
        },
        kartbilgisigetir(kartno) {
            this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartNo = kartno
            this.kredikartdialog = false
        },
        kurgetir(tarih, kod) {
            var params1 = {
                Tarih: tarih,
                DovizKod: kod
            }

            if (tarih != null && tarih != '') {
                this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
                    headers: auth.getAuthCompaniesInfo()
                }).then((response) => {
                    if(response.body == 0.0){
                        this.BiletAyrintiliOdeme.Kur = 1
                    }else{
                    this.BiletAyrintiliOdeme.Kur = response.body
                    }
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-Kur Hesapla'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-Kur Hesapla'
                        this.snackbar = true
                    }
                })
            }
        },

        sayfakapatiade() {

            var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + this.BiletIade.GenelBilgileri.HavaYoluKodu +
                '&biletno=' +
                this.BiletIade.GenelBilgileri.BiletNo + '&ucustipi=' + this.BiletIade.GenelBilgileri.UcusTip
            window.open(url, '_self')
        },
        yeniiadeekle() {
            var url = '#/bilet/biletiade/id?' + 'isl=yeniiade&hyolukod=' + this.BiletIade.GenelBilgileri.HavaYoluKodu +
                '&biletno=' + this.BiletIade.GenelBilgileri.BiletNo + '&formno=' + this.BiletIade.GenelBilgileri.Formno
            window.open(url, '_target')
            window.location.reload(false);

        },

        ekle: ekle,
        iadekaydet: iadekaydet,
        iadeiptal: iadeiptal,
        tutarTopla,
        dovizTutarTopla

    },
    beforeMount: beforeMount,

    components: {
        'parainput': parainput,
        'dovizinput': dovizinput,
        'yuzdeinput': yuzdeinput,
        'tarihcomp': tarihcomp,
        cariaracomp,
        doviztutarcomp,
        kesenkisi,
        yetkidialog,
        faturacomp,
        snackbarcomp
    },
    watch: {
        loadingdialog(val) {
            if (!val) return
            setTimeout(() => (this.loadingdialog = false), 4000)
        },

        'BiletIade.TutarBilgileri.Tutar.Tutar': function (value1) {
            this.tutarTopla();
        },
        'BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiTutar': function (value1) {
            this.tutarTopla();
        },
        'BiletIade.TutarBilgileri.IadeServisTutar.IadeServisTutar': function (value1) {
            this.tutarTopla();

        },
        'BiletIade.TutarBilgileri.TaxTutar.TaxTutar': function (value1) {
            this.tutarTopla();
        },
        'BiletIade.TutarBilgileri.YffTutar.YFFTutar': function (value1) {
            this.tutarTopla();
        },
        'BiletIade.TutarBilgileri.IskontoTutar.IskontoTutar': function (value1) {
            this.tutarTopla();
        },
        'BiletIade.TutarBilgileri.CezaTutar.CezaTutar': function (value1) {
            this.tutarTopla();
        },
        'BiletIade.TutarBilgileri.KaTutar.KaTutar': function (value1) {
            this.tutarTopla();
        },
        'BiletIade.TutarBilgileri.DigerServisTutar.DigerServisTutar': function (value1) {
            this.tutarTopla();
        },
        'BiletIade.TutarBilgileri.ReserveTutar.ReserveTutar': function (value1) {
            this.tutarTopla();
        },
        'BiletIade.TutarBilgileri.Tutar.TutarSatisDoviz': function (value1) {
            //   this.BiletIade.TutarBilgileri.Tutar.Tutar = this.BiletIade.TutarBilgileri.Kur * value1
        },
        'BiletIade.TutarBilgileri.CezaTutar.CezaSatisTutar': function (value1) {
            //  this.BiletIade.TutarBilgileri.CezaTutar.CezaTutar = this.BiletIade.TutarBilgileri.Kur * value1
        },
        'BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz': function (value1) {
            //  this.BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiTutar = this.BiletIade.TutarBilgileri.Kur * value1
        },
        'BiletIade.TutarBilgileri.IskontoTutar.IskontoDoviz': function (value1) {
            //  this.BiletIade.TutarBilgileri.IskontoTutar.IskontoTutar = this.BiletIade.TutarBilgileri.Kur * value1
        },
        'BiletIade.TutarBilgileri.DigerServisTutar.DigerServisDoviz': function (value1) {
            //   this.BiletIade.TutarBilgileri.DigerServisTutar.DigerServisTutar = this.BiletIade.TutarBilgileri.Kur *
            //     value1
        },

        'BiletIade.TutarBilgileri.TaxTutar.TaxSatisDoviz': function (value1) {
            //  this.BiletIade.TutarBilgileri.TaxTutar.TaxTutar = this.BiletIade.TutarBilgileri.Kur * value1
        },
        'BiletIade.TutarBilgileri.ReserveTutar.ReserveDoviz': function (value1) {
            //  this.BiletIade.TutarBilgileri.ReserveTutar.ReserveTutar = this.BiletIade.TutarBilgileri.Kur * value1
        },
        'BiletIade.TutarBilgileri.Tutar.TutarAlisDoviz': function (value1) {
            this.dovizTutarTopla();
        },
        'BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiAlisDoviz': function (value1) {
            this.dovizTutarTopla();
        },
        'BiletIade.TutarBilgileri.CezaTutar.CezaAlisTutar': function (value1) {
            this.dovizTutarTopla();
        }
    }
}

function iadeiptal() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var paramsiade = {
        SirketKodu: credentials.SirketKodu,
        BiletNo: this.BiletIade.GenelBilgileri.BiletNo,
        FormNo: this.BiletIade.GenelBilgileri.Formno,
        SiraNo: this.BiletIade.GenelBilgileri.Sirano,
        IadeTarihi: this.BiletIade.TarihBilgileri.IadeTarihi,
    }

    this.$http.post(auth.API_URL + 'api/Ticket/RefundDelete', paramsiade, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

         this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true
        var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + this.BiletIade.GenelBilgileri.HavaYoluKodu +
            '&biletno=' +
            this.BiletIade.GenelBilgileri.BiletNo + '&ucustipi=' + this.BiletIade.GenelBilgileri.UcusTip

        setTimeout(function () {
            window.open(url, '_self')
            // window.location.reload(false);
        }.bind(this), 5000)

    }, (response) => {
         this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        } else {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
        }
    })
}

function iadekaydet() {
    this.loadingdialogkayit = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
        MusteriID: credentials.MusteriID,
        HareketTip: 'Iade',
        HareketSayisi: 1
    }

    this.$http.post(auth.API_URL + 'api/Register/PackageCustomerInfos', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

        if (response.body.UyelikStatus == true) {

            if (response.body.KontorStatus == true) {

                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                this.BiletIade.GenelBilgileri.SirketKodu = credentials.SirketKodu

                var paramsbilet = this.BiletIade

                this.$http.post(auth.API_URL + 'api/Ticket/RefundAdd', paramsbilet, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true

                    if (response.body.Status == true) {
                        var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + this.BiletIade.GenelBilgileri
                            .HavaYoluKodu +
                            '&biletno=' +
                            this.BiletIade.GenelBilgileri.BiletNo + '&ucustipi=' + this.BiletIade.GenelBilgileri.UcusTip

                        setTimeout(function () {
                            window.open(url, '_self')
                            // window.location.reload(false);
                        }.bind(this), 5000)
                    }

                }, (response) => {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                    this.loadingdialogkayit = false;

                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true;
                        this.loadingdialogkayit = false;

                    } else {
                         this.text1 = this.$t(response.body.ResponseMessage)
                        this.snackbar = true
                        this.loadingdialogkayit = false;
                    }

                })

            } else {
                this.text1 = this.$t('not-process-need-purchase-continue-process')
                this.snackbar = true
                this.loadingdialogkayit = false
            }

        } else {
            this.text1 = this.$t('membership-expired-need-renew-membership-process')
            this.snackbar = true
            this.loadingdialogkayit = false
        }
    }, (response) => {

        if (response.status === 0) {
            this.text1 = 'Service Unavailable-ProductCustomerInfo'
            this.snackbar = true
            this.loadingdialogkayit = false

        } else {
            this.text1 = 'Service Unavailable-ProductCustomerInfo'
            this.snackbar = true
            this.loadingdialogkayit = false

        }

    })

}

function beforeMount() {}

function dovizTutarTopla() {
    this.BiletIade.TutarBilgileri.NetTutar.NetTutarAlisDoviz = this.BiletIade.TutarBilgileri.Tutar
        .TutarAlisDoviz +
        this.BiletIade.TutarBilgileri.CezaTutar.CezaAlisTutar + this.BiletIade.TutarBilgileri.AlanVergiTutar
        .AlanVergiAlisDoviz
}

function tutarTopla() {

    this.BiletIade.TutarBilgileri.NetTutar.NetTutar =
        this.BiletIade.TutarBilgileri.Tutar.Tutar +
        this.BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiTutar +
        this.BiletIade.TutarBilgileri.TaxTutar.TaxTutar +
        this.BiletIade.TutarBilgileri.YffTutar.YFFTutar +
        this.BiletIade.TutarBilgileri.DigerServisTutar.DigerServisTutar +
        this.BiletIade.TutarBilgileri.CezaTutar.CezaTutar +
        this.BiletIade.TutarBilgileri.IadeServisTutar.IadeServisTutar +
        this.BiletIade.TutarBilgileri.ReserveTutar.ReserveTutar +
        this.BiletIade.TutarBilgileri.KaTutar.KaTutar -
        this.BiletIade.TutarBilgileri.IskontoTutar.IskontoTutar

    this.BiletIade.CezasızTutar = this.BiletIade.TutarBilgileri.NetTutar.NetTutar - this.BiletIade.TutarBilgileri
        .CezaTutar.CezaTutar

    if (this.BiletIade.TutarBilgileri.Kur > 0) {
        this.BiletIade.TutarBilgileri.NetTutar.NetTutarSatisDoviz = this.BiletIade.TutarBilgileri.NetTutar
            .NetTutar /
            this.BiletIade.TutarBilgileri.Kur
        this.BiletIade.TutarBilgileri.Tutar.TutarSatisDoviz = this.BiletIade.TutarBilgileri.Tutar.Tutar / this
            .BiletIade.TutarBilgileri.Kur

        this.BiletIade.TutarBilgileri.CezaTutar.CezaSatisTutar = this.BiletIade.TutarBilgileri.CezaTutar.CezaTutar /
            this
            .BiletIade.TutarBilgileri.Kur

        this.BiletIade.TutarBilgileri.TaxTutar.TaxSatisDoviz = this.BiletIade.TutarBilgileri.TaxTutar.TaxTutar /
            this
            .BiletIade.TutarBilgileri.Kur

        this.BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz = this.BiletIade.TutarBilgileri
            .AlanVergiTutar
            .AlanVergiTutar /
            this.BiletIade.TutarBilgileri.Kur

        this.BiletIade.TutarBilgileri.IskontoTutar.IskontoDoviz = this.BiletIade.TutarBilgileri.IskontoTutar
            .IskontoTutar /
            this.BiletIade.TutarBilgileri.Kur

        this.BiletIade.TutarBilgileri.DigerServisTutar.DigerServisDoviz = this.BiletIade.TutarBilgileri
            .DigerServisTutar
            .DigerServisTutar /
            this.BiletIade.TutarBilgileri.Kur

        this.BiletIade.TutarBilgileri.ReserveTutar.ReserveDoviz = this.BiletIade.TutarBilgileri.ReserveTutar
            .ReserveTutar /
            this.BiletIade.TutarBilgileri.Kur

        this.BiletIade.TutarBilgileri.IadeServisTutar.IadeServisDoviz = this.BiletIade.TutarBilgileri
            .IadeServisTutar
            .IadeServisTutar /
            this.BiletIade.TutarBilgileri.Kur

        this.BiletIade.TutarBilgileri.KaTutar.KaDoviz = this.BiletIade.TutarBilgileri
            .KaTutar
            .KaTutar /
            this.BiletIade.TutarBilgileri.Kur

       this.BiletIade.TutarBilgileri.YffTutar.YFFDoviz = this.BiletIade.TutarBilgileri
            .YffTutar
            .YFFTutar /
            this.BiletIade.TutarBilgileri.Kur

       this.BiletIade.TutarBilgileri.ServisTutar.ServisDoviz = this.BiletIade.TutarBilgileri
            .ServisTutar
            .ServisTutar /
            this.BiletIade.TutarBilgileri.Kur

    }

    if (this.SatisSekli == 'P') {
        this.BiletIade.OdemeBilgileri.PesinTutar = this.BiletIade.TutarBilgileri.NetTutar.NetTutar
        this.BiletIade.OdemeBilgileri.PesinDvzTutar = this.BiletIade.TutarBilgileri.NetTutar.NetTutar / this.BiletIade
            .TutarBilgileri.Kur

    } else if (this.SatisSekli == 'K') {
        this.BiletIade.OdemeBilgileri.KrediliTutar = this.BiletIade.TutarBilgileri.NetTutar.NetTutar
        this.BiletIade.OdemeBilgileri.KrediliDvzTutar = this.BiletIade.TutarBilgileri.NetTutar.NetTutar / this.BiletIade
            .TutarBilgileri.Kur
    } else if (this.SatisSekli == 'C' || this.SatisSekli == 'R' || this.SatisSekli == 'F') {
        this.BiletIade.OdemeBilgileri.KrediKartTutar = this.BiletIade.TutarBilgileri.NetTutar.NetTutar
        this.BiletIade.OdemeBilgileri.KrediKartDvzTutar = this.BiletIade.TutarBilgileri.NetTutar.NetTutar / this.BiletIade
            .TutarBilgileri.Kur
    }

}

function ekle() {
    this.$validator.validateAll().then((result) => {
        if (result) {

            var current = this.Bilet

            this.$http.post(auth.API_URL + 'api/Current/New', current, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                if (response.body.Status === true) {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                } else if (response.body.Status === false) {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                }
            }, (response) => {
                if (response.status === 0) {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                } else {
                    let data ={
                    response: response,
                    request: current,
                    api:'Current/New',
                    type:2,
                    message: response.body.ExceptionMessage
                    };
                    this.$refs.showMessage.open(data);
                }
            })
        } else {
            this.active = 0;
        }
    })
}
</script>

<style>
</style>
